import React from 'react';
import PropTypes from 'prop-types';
import { DeleteOutlined, ReloadOutlined, EyeOutlined } from '@ant-design/icons';
import { Spin, Typography } from 'antd';
import { AttachmentItem } from './style';
import { FileIcon } from '../../../fileIcon/fileIcon';
import { ActionButton } from '../style';
import constants from '../../../../config/api/constants';

export const AttachmentList = ({ defaultValue = [], readOnly, getRemoveItemHandler = ()=>{},getRetryUploadItemHandler= ()=>{} }) => {
  const getAttachmentUrl = attachmentUrl => {
    return `${constants.s3Path}/${attachmentUrl}`;
  };

  return (
    <ul>
      {defaultValue.map(attachmentData => {
        return (
          <Spin key={attachmentData.id} spinning={attachmentData.loading}>
            <li>
              <AttachmentItem>
                <FileIcon className="attachment-file-icon" filename={attachmentData.filename} size="60px" />
                <Typography.Text
                  type={attachmentData.hasError ? 'danger' : 'default'}
                  className="attachment-filename"
                >
                  {attachmentData.filename}
                </Typography.Text>
                {attachmentData.hasError ? (
                  <ActionButton
                    className="attachment-action"
                    onClick={getRetryUploadItemHandler(attachmentData)}
                    icon={<ReloadOutlined />}
                  />
                ) : (
                  <a href={getAttachmentUrl(attachmentData.url)} target="__blank" rel="noopener noreferrer">
                    <ActionButton
                      className="attachment-action"
                      onClick={getRetryUploadItemHandler(attachmentData)}
                      icon={<EyeOutlined />}
                    />
                  </a>
                )}
                {
                  !readOnly ?
                    <ActionButton
                      className="attachment-action"
                      onClick={getRemoveItemHandler(attachmentData)}
                      icon={<DeleteOutlined />}
                    />
                    : null
                }
              </AttachmentItem>
            </li>
          </Spin>
        );
      })}
    </ul>
  );
};

AttachmentList.propTypes = {
  readOnly: PropTypes.bool,
  defaultValue: PropTypes.arrayOf(
    PropTypes.shape({
      fileName: PropTypes.string, // this naming case come from tapptus v1
      url: PropTypes.string,
    }),
    ),
  getRemoveItemHandler: PropTypes.func,
  getRetryUploadItemHandler: PropTypes.func,
};
